// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"9ae017f0","566":"1ea962e4","777":"038769be","839":"913e7495"}[chunkId] + ".chunk.js";
};